module.exports = __webpack_public_path__ + "img/cert21.86f63bce.jpg";